<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row new-updated-design">
                <div class="col-md-6 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin mb-0">
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="card-title" v-if="form.id == ''">Add New User</h4>
                                    <h4 class="card-title" v-else>Update Role</h4>
                                </div>
                                <div class="card-body new-card-body">
                                    <!--                                <form class="forms-sample" @submit.stop.prevent="onSubmit" autocomplete="off">-->
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <b-form-group label="Client*" label-for="Client">
                                                <!--                                                <b-form-select :options="clients"-->
                                                <!--                                                               multiple-->
                                                <!--                                                               class="cst-new-select"-->
                                                <!--                                                               v-model="$v.form.client_id.$model"-->
                                                <!--                                                               :state="$v.form.client_id.$dirty ? !$v.form.client_id.$error : null"-->
                                                <!--                                                               aria-describedby="input-2-live-feedback"-->
                                                <!--                                                ></b-form-select>-->
                                                <v-select multiple v-model="form.client_id"
                                                          aria-describedby="input-2-live-feedback" :options="clients"
                                                          :reduce="name => name.id"
                                                          label="name"
                                                          autofocus
                                                          :class="{ 'is-invalid-multi' : multiSelectError === true , 'is-valid':multiSelectError === false }"
                                                          @input="changeClient">
                                                </v-select>
                                                <div v-if="multiSelectError"
                                                     class="custom-invalid-feedback"
                                                     id="input-2-live-feedback">
                                                    This is a
                                                    required field
                                                </div>
                                                <!--                                                <b-form-invalid-feedback v-if="form.client_id.required" id="input-4-live-feedback">{{ $t("field-required") }}</b-form-invalid-feedback>-->
                                            </b-form-group>
                                            <b-form-group label="Name*" label-for="name">
                                                <b-form-input
                                                        type="text"
                                                        id="name"
                                                        name="name"
                                                        autocomplete="new-password"
                                                        placeholder="Name"
                                                        v-model="$v.form.name.$model"
                                                        :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
                                                        aria-describedby="input-1-live-feedback"
                                                >
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-lg-6">
                                            <b-form-group label="Email*" label-for="email">
                                                <b-form-input
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        autocomplete="new-password"
                                                        placeholder="Email"
                                                        v-model="$v.form.email.$model"
                                                        :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
                                                        aria-describedby="input-3-live-feedback"
                                                >
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="!$v.form.email.required"
                                                                         id="input-3-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                                <b-form-invalid-feedback v-if="form.email && !$v.form.email.email"
                                                                         id="input-3-live-feedback">Invalid Email.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                            <b-form-group label="Password" label-for="password">
                                                <b-form-input
                                                        type="password"
                                                        id="password"
                                                        name="password"
                                                        autocomplete="new-password"
                                                        placeholder="Password"
                                                        v-model="$v.form.password.$model"
                                                        :state="$v.form.password.$dirty ? !$v.form.password.$error : null"
                                                        aria-describedby="input-4-live-feedback"
                                                >
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="!$v.form.password.required"
                                                                         id="input-4-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                                <b-form-invalid-feedback v-if="!$v.form.password.minLength"
                                                                         id="input-4-live-feedback">Password must have
                                                    at least
                                                    {{ $v.form.password.$params.minLength.min }} letters.
                                                </b-form-invalid-feedback>
                                                <b-form-invalid-feedback v-if="form.password && !$v.form.password.valid && $v.form.password.minLength"
                                                                         id="input-4-live-feedback">Password contains
                                                    atleast
                                                    One Uppercase, One Lowercase, One Number and One Special Character.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-lg-12">
                                            <b-form-group label="Role*" label-for="Role">
                                                <b-form-select :options="roles"
                                                               class="cst-new-select"
                                                               v-model="$v.form.role_name.$model"
                                                               :state="$v.form.role_name.$dirty ? !$v.form.role_name.$error : null"
                                                               aria-describedby="input-4-live-feedback"
                                                ></b-form-select>
                                                <b-form-invalid-feedback id="input-4-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                        </div>
                                        <div class="col-md-6 mt-0">
                                            <b-button type="submit" variant="success" :disabled="isDisabled" class="mr-0 float-right">
                                                <span v-if="form.id == ''">Submit</span>
                                                <span v-else>Update</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <!--                                </form>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin mb-0">
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="card-title">User Login</h4>
                                </div>
                                <div class="card-body new-card-body">
                                    <b-form-group label="Title" label-for="title">
                                        <b-form-input
                                                type="text"
                                                id="title"
                                                name="title"
                                                autocomplete="new-password"
                                                placeholder="Title"
                                                v-model="form.title"
                                        >
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group label="Mobile Phone" label-for="mobile_phone">
                                        <b-form-input
                                                type="text"
                                                id="mobile_phone"
                                                name="mobile_phone"
                                                autocomplete="new-password"
                                                placeholder="Mobile Phone"
                                                v-model="form.mobile_phone"
                                        >
                                        </b-form-input>
                                    </b-form-group>
                                    <b-button type="button" @click="loginAs" v-if="form.id && user_clients_count > 0"
                                              variant="success"
                                              class="mr-2">
                                        Login As
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="row new-updated-design">

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Users</h4>
                    </div>
                    <div class="card-body new-card-body">
                        <vue-good-table
                                mode="remote"
                                @on-page-change="onPageChange"
                                @on-sort-change="onSortChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                :totalRows="totalRecords"
                                :isLoading.sync="isLoading"
                                @on-search="searchFn"
                                :search-options="{enabled: true,searchFn: searchFn}"
                                :pagination-options="{
    enabled: true,
      dropdownAllowAll: false,
    perPageDropdown: [10, 20, 50, 100, 200],
  }"
                                :rows="rows"
                                :columns="columns">
                            <template slot="table-row" slot-scope="props">
                                                             <span
                                                                     v-if="props.column.field === 'action'"
                                                                     class="text-nowrap"
                                                             >
                                                                 <b-button size="sm" @click="editUser(props.row.id)"
                                                                           class="mr-1 btn-info text-white">
                                                                Edit
                                                            </b-button>
                                                            <b-button size="sm" @click="deleteUser(props.row.id)"
                                                                      class="mr-1 btn-danger text-white">
                                                                Delete
                                                            </b-button>
                                                             </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modalClient" ref="vuemodal" title="Please Select a Project" size="md" hide-footer>
            <form class="forms-sample" @submit.stop.prevent="loginClient" autocomplete="off">
                <b-form-group label="Project*" label-for="client">
                    <b-form-select v-model="$v.client_form.login_client_id.$model"
                                   :state="$v.client_form.login_client_id.$dirty ? !$v.client_form.login_client_id.$error : null"
                                   aria-describedby="input-1-live-feedback" :options="clientArr"></b-form-select>
                    <b-form-invalid-feedback id="input-1-live-feedback">{{ $t("field-required") }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-button type="submit" variant="success" class="mr-2">
                    Submit
                </b-button>
            </form>
        </b-modal>
    </section>
</template>

<script>
    import Vue from "vue";
    import SortedTablePlugin from "vue-sorted-table";
    import API from '@/api'
    import Snotify, {SnotifyPosition} from 'vue-snotify'
    import {validationMixin} from "vuelidate";
    import {required, minLength, email, requiredIf, sameAs} from "vuelidate/lib/validators";
    import router from "../router";

    const options = {
        toast: {
            position: SnotifyPosition.rightTop,
        }
    }
    Vue.use(Snotify, options)
    Vue.use(SortedTablePlugin, {
        ascIcon: '<i class="ti-arrow-down"></i>',
        descIcon: '<i class="ti-arrow-up"></i>'
    });
    export default {
        name: 'Users',
        mixins: [validationMixin],
        data() {
            return {
                form: {
                    name: "",
                    email: "",
                    password: "",
                    id: "",
                    client_id: [],
                    title: "",
                    mobile_phone: "",
                    role_name: ""
                },
                clientArr: [],
                clientFullArr: [],
                client_form: {
                    login_client_id: '',
                },
                user_clients_count: 0,
                serverParams: {
                    // a map of column filters example: {name: 'john', age: '20'}
                    columnFilters: {},
                    sort: [
                        {
                            field: 'id', // example: 'name'
                            type: 'desc' // 'asc' or 'desc'
                        }
                    ],

                    page: 1, // what page I want to show
                    perPage: 10 // how many items I'm showing per page
                },
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                        filterable: true
                    },
                    {
                        label: 'Role',
                        field: 'roles',
                        filterable: true,
                        sortable: false,
                        formatFn: this.formatRole
                    },
                    {
                        label: 'Email',
                        field: 'email',
                        filterable: true
                    },
                    {
                        label: 'Client',
                        field: 'user_clients',
                        sortable: false,
                        formatFn: this.formatFn
                    },
                    {
                        label: 'Action',
                        field: "action",
                        sortable: false,
                    },
                ],
                isLoading: false,
                multiSelectError: false,
                rows: [],
                totalRecords: 0,
                roles: [],
                clients: [],
                isDisabled: false,
            };
        },
        validations: {
            client_form: {
                login_client_id: {
                    required,
                },
            },
            form: {
                id: {},
                name: {
                    required,
                }, email: {
                    email,
                    required,
                }, role_name: {
                    required,
                }, password: {
                    required: requiredIf((value) => value.id === ''),
                    minLength: minLength(6),
                    valid: function (value) {
                        const containsUppercase = /[A-Z]/.test(value)
                        const containsLowercase = /[a-z]/.test(value)
                        const containsNumber = /[0-9]/.test(value)
                        const containsSpecial = /[#?!@$%^&*-]/.test(value)
                        return containsUppercase && containsLowercase && containsNumber && containsSpecial
                    },
                }

            }
        },
        methods: {
            getUserRoles() {
                API.getUserRoles(
                    data => {
                        this.roles = data;
                        // this.form.role_name = 'Admin';
                        let one = 1;
                        for (var i in this.roles) {
                            if (one == 1) {
                                ++one;
                                this.form.role_name = i;
                                this.$v.form.$reset();
                            }
                        }
                    },
                    err => {
                    }
                )
            },

            getAllUsers() {
                API.getAllUser(
                    data => {
                        this.users = data
                    },
                    err => {
                    }
                )
            },
            getAllClients() {
                API.get_all_cleints('',
                    data => {
                        const clients_data = data;
                        this.clients = [];

                        clients_data.forEach((value) => {
                            this.clients.push({
                                id: value.id,
                                name: value.name,
                            })
                        });

                        // IMPORTANT:
                        // vue-select is using :reduce, so form.client_id must be an array of client IDs.
                        // Also, do NOT wipe/overwrite client_id while editing a user (that caused random
                        // wrong selections depending on which async request finished last).
                        if (this.form.id === '' && this.form.client_id.length === 0 && this.clients.length > 0) {
                            // old behaviour: preselect first client on "Add New User"
                            this.form.client_id = [this.clients[0].id];
                        }

                        this.$v.form.$reset();
                    },
                    err => {
                    }
                )
            },
            deleteUser(e) {
                this.$swal({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        let data = {
                            id: e
                        }
                        API.deleteUser(
                            data,
                            data => {
                                this.loadItems();
                                this.$swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                )
                            },
                            err => {
                            })
                    }
                })
            },
            editUser(e) {
                window.scrollTo({top: 0, behavior: 'smooth'});
                this.$v.form.$reset();

                // Refresh list (but getAllClients no longer overwrites selection)
                this.getAllClients();

                // Reset per-edit state to avoid leaking previous user's clients
                                this.clientArr = [];
                this.clientFullArr = [];
                this.form.client_id = [];
                this.multiSelectError = false;

                API.get_edit_user(
                    e, data => {
                        this.user_clients_count = data.user_clients_count;
                        this.form.name = data.name;
                        this.form.id = data.id;
                        this.form.email = data.email;
                        this.form.mobile_phone = data.mobile_phone;
                        this.form.title = data.title;

                        if (data.roles.length !== 0) {
                            this.form.role_name = data.roles[0].name;
                        } else {
                            this.form.role_name = '';
                        }

                        if (data.user_clients && data.user_clients.length > 0) {
                            // vue-select + reduce => array of IDs
                                                        this.form.client_id = data.user_clients
                                .filter(uc => uc.clients && uc.clients.id)
                                .map(uc => uc.clients.id);
                            this.multiSelectError = this.form.client_id.length === 0;


                            data.user_clients.forEach((uc) => {
                                if (uc.clients) {
                                    this.clientArr.push({
                                        value: uc.clients.id,
                                        text: uc.clients.name,
                                    })
                                }
                            })

                            this.clientFullArr = data.user_clients;
                            localStorage.setItem('clientArr', JSON.stringify(this.clientFullArr))
                            localStorage.setItem('user_clients_count', JSON.stringify(data.user_clients.length))
                        }

                    },
                    err => {
                    }
                )
            },
            onSubmit() {
                this.$v.form.$touch();
                console.log(this.$v.form.$anyError)
                if (this.$v.form.$anyError) {
                    if (!this.$v.form.password.valid && this.$v.form.password != '' && this.$v.form.password !== '' && this.form.client_id.length > 0) {
                        this.isDisabled = true;
                        this.userForm();
                    } else {
                        return;
                    }
                } else {
                    console.log(this.form.name, this.form.email, this.form.role_name, this.form.client_id)
                    if (this.form.name != '' && this.form.email != '' && this.form.role_name != '' && this.form.client_id.length > 0) {

                        this.isDisabled = true;
                        this.userForm();
                    } else {
                        this.isDisabled = false;
                        this.$snotify.warning('Please fill required fields', {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                        });

                    }
                }
            }, resetForm() {
                var self = this; //you need this because *this* will refer to Object.keys below`

                //Iterate through each object field, key is name of the object field`
                Object.keys(this.data.form).forEach(function (key, index) {
                    self.data.form[key] = '';
                });
            }, userForm() {
                API.add_edit_users(
                    this.form,
                    data => {
                        this.isDisabled = false;
                        this.$snotify.success(data, {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                                                });

                        this.form.name = '';
                        this.form.email = '';
                        this.form.password = '';
                        this.form.id = '';
                        this.form.client_id = [];
                        this.form.mobile_phone = '';
                        this.form.title = '';
                        this.getAllClients();
                        this.loadItems();
                        this.$v.form.$reset();
                        this.getUserRoles();
                    },
                    err => {
                        this.isDisabled = false;
                        console.log(err['data']['errors']['email'][0]);
                        this.$snotify.error(err['data']['errors']['email'][0], {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                        });
                    }
                )
            },


            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                console.log(params.sortType);
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            searchFn(params) {
                this.updateParams({searchTerm: params});
                this.loadItems();
            },
            loadItems() {
                API.getAllUser(this.serverParams,
                    data => {
                        this.totalRecords = data.totalRecords;
                        this.rows = data.data.data;
                        // this.users = data
                    },
                    err => {
                    }
                )
            },
            formatFn: function (value) {
                var data = [];
                if (value.length > 0) {
                    value.forEach((value, index) => {
                        if(value.clients) {
                            data.push(value.clients.name)
                        }
                    })
                }

                return data.toString();

            },
            formatRole: function (value) {
                if (value[0] != null && typeof value[0].name != 'undefined') {
                    return value[0].name;
                }
            },
            changeClient(event) {
                console.log(event)
                if (event.length === 0) {
                    this.multiSelectError = true;
                } else {
                    this.multiSelectError = false;
                }
            },
                        loginAs() {
                if (this.user_clients_count === 1) {
                    let data = {
                        email: this.form.email,
                        client_id: this.form.client_id[0],
                    }
                    var admin_email = JSON.parse(localStorage.getItem('user'));
                    API.loginAs(data,
                        data => {
                            if (typeof data.token !== "undefined") {
                                localStorage.setItem('isLoggedin', data.token)
                                localStorage.setItem('client_settings', JSON.stringify(data.client_settings))
                                localStorage.setItem('user', JSON.stringify(data.user))
                                localStorage.setItem('userPermissions', JSON.stringify(data.permission))
                                localStorage.setItem('super_admin_email', admin_email.email)
                                localStorage.setItem('client_id', this.form.client_id[0])
                                router.push("/dashboard")
                                router.go("/dashboard")
                            }
                        },
                        err => {
                        }
                    )
                } else {
                    this.$root.$emit("bv::show::modal", "modalClient");
                }
            },
            loginClient() {
                this.$v.client_form.$touch();
                if (this.$v.client_form.$anyError) {
                    return
                }

                if (this.client_form.login_client_id !== '') {
                    let data = {
                        email: this.form.email,
                        client_id: this.client_form.login_client_id,
                    }
                    var admin_email = JSON.parse(localStorage.getItem('user'));
                    API.loginAs(data,
                        data => {
                            if (typeof data.token !== "undefined") {
                                console.log(data)
                                localStorage.setItem('isLoggedin', data.token)
                                localStorage.setItem('client_settings', JSON.stringify(data.client_settings))
                                localStorage.setItem('user', JSON.stringify(data.user))
                                localStorage.setItem('userPermissions', JSON.stringify(data.permission))
                                localStorage.setItem('super_admin_email', admin_email.email)
                                localStorage.setItem('client_id', this.client_form.login_client_id)
                                router.push("/dashboard")
                                router.go("/dashboard")
                            }
                        },
                        err => {
                        }
                    )
                }
            }

        }, computed: {},
        mounted() {
            this.loadItems();
            this.getUserRoles();
            this.getAllClients();
        }
    }
</script>

<style>
    .row .card .new-card-body {
        padding: 1.25rem 1.437rem !important;
    }
    @media (max-width: 450px) {
        .vgt-wrap__footer .footer__navigation__page-btn:nth-child(3) {
            float: right;
            margin-left: 8px;
        }
        .vgt-wrap__footer .footer__navigation__page-btn:nth-child(2) {
            margin-left: 0px;
            float: left;
        }
        .vgt-wrap__footer .footer__navigation__page-info {
            width: 100%;
            text-align: center;
            margin: 0;
        }
        .vgt-pull-right {
            float: inherit !important;
        }
    }
    @media (max-width: 375px) {
        .row .card .new-card-body {
            padding: 1.25rem 1.437rem !important;
        }
    }
</style>
